import createNewsItem from "@/store/modules/newsItems/createNewsItem";
import { NewsMLJsonDetail, NewsItemDetail } from "./types.d";

export default (obj: NewsMLJsonDetail): NewsItemDetail => ({
  ...createNewsItem(obj),
  by: obj.by,
  htmlBody: obj.html_body,
  creditLine: obj.creditline,
  link: obj.link,
  genre: obj.genre,
  // NB: Map poi from subjects as new view model as it is filtered out for tags
  places: obj.subject.filter(
    item => item.type === "http://cv.iptc.org/newscodes/cpnature/poi"
  ),
  body: obj.body,
  itemClass: obj.item_class ? obj.item_class.split("/").pop() : null,
  remoteContent:
    obj.remote_content && obj.remote_content.length
      ? obj.remote_content.map(content => {
          return {
            residref: content.residref,
            layoutOrientation: content.layoutorientation,
            contentType: content.contenttype,
            colourIndicator: content.colourindicator,
            ...content
          };
        })
      : [],
  located: { localityName: obj.located ? obj.located.locality_name : "" },
  provider: obj.provider,
  copyrightHolder: { ...obj.copyright_holder }
});
